export type SortDirection = "asc" | "desc";

/**
 * Sorts a copy of `items` by a derived key. Stable (uses Array#sort, which is
 * a stable sort in engines targeted by this project).
 */
export function sortBy<T>(items: T[], key: (item: T) => number | string, direction: SortDirection = "asc"): T[] {
  const factor = direction === "asc" ? 1 : -1;
  return [...items].sort((a, b) => {
    const av = key(a);
    const bv = key(b);
    if (av < bv) return -1 * factor;
    if (av > bv) return 1 * factor;
    return 0;
  });
}
